import React from "react";
import NewPassword from "../../organisms/InitialPagesComponents/NewPassword/NewPassword";

const NewPasswordPage = () => {
  return <NewPassword />;
};

export default NewPasswordPage;
